import type { IRecordTypeDefinition } from '@platform/core/types';

/** Заголовки статті Markdown для «На цій сторінці» (рядки «#», «##», «###», без символів розмітки). Чиста функція. */
export function articleToc(body: string): string[] {
  return body.split('\n').filter((l) => /^#{1,3}\s/.test(l)).map((l) => l.replace(/^#+\s*/, '').replace(/[*_`]/g, '').trim()).filter(Boolean);
}

/** Чи тип запису — стаття (текст Markdown `body` і вкладки «Читання · Редагувати» у визначенні форми). Чиста функція. */
export function isArticleType(rt: Pick<IRecordTypeDefinition, 'fields' | 'form'>): boolean {
  return rt.form.tabs.includes('read') && rt.fields.some((f) => f.key === 'body' && f.type === 'textarea');
}
